var _a;
import { DrivePadType } from '../entity/file-meta.interface';
// 每次使用时检查：和全局类型 SupportType 保持一致
export var supportTypeMap = (_a = {},
    _a[DrivePadType.UNKNOWN] = /jpg|jpeg|bmp|gif|png|webp|avi|mp4|mkv|mov|webm|opus|flv|hls|ts|dash|mp3|aac|flac|wav|amr/,
    _a[DrivePadType.DOC] = /doc|dot|wps|wpt|docx|dotx|docm|dotm/,
    _a[DrivePadType.SHEET] = /xls|xlt|xlsx|xltx|csv|xlsb|xlsm|xltm|et|ett|ets/,
    _a[DrivePadType.TEXT] = /lrc|c|cpp|h|asm|s|java|asp|bat|bas|prg|cmd|rtf|txt|log|xml|htm|html/,
    _a[DrivePadType.SLIDE] = /pptx|ppt|pot|potx|pps|ppsx|dps|dpt|pptm|potm|ppsm/,
    _a);
export var supportConvertedExtRegExp = /(doc|docx|xls|xlsx|txt|csv|ppt|pptx)$/i;
